import React, { createContext, useContext, useMemo } from 'react';

// null = no override, useGlobalFilters() falls through to the true global filter state.
const TabFilterOverrideContext = createContext(null);

// Mirrors hasLocalFilters() in useLocalFilters.js — an empty/default tabFilters
// object must never shadow the global filter state.
export function hasActiveFilters(f) {
  if (!f) return false;
  if (f.objectTypes?.length > 0) return true;
  if (f.dateRange?.enabled) return true;
  if (f.eventAttributeFilters?.some((x) => x.enabled)) return true;
  if (f.activityFilters?.enabled) return true;
  if (f.leadTimeRange?.enabled) return true;
  if (f.objectAttributePresenceFilters?.enabled) return true;
  if (f.objectAttributeFilters?.some((x) => x.enabled)) return true;
  if (f.variantFilter?.enabled) return true;
  if (f.edgeDurationFilters?.length > 0) return true;
  if (f.edgeContainmentFilters?.enabled) return true;
  if (f.activityNodeFilters?.enabled) return true;
  return false;
}

export const TabFilterProvider = ({ tabFilters, children }) => {
  const value = useMemo(() => (hasActiveFilters(tabFilters) ? tabFilters : null), [tabFilters]);
  return (
    <TabFilterOverrideContext.Provider value={value}>
      {children}
    </TabFilterOverrideContext.Provider>
  );
};

export const useTabFilterOverride = () => useContext(TabFilterOverrideContext);
